import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

// Configurações → Correio: o servidor de e-mail DO ESCRITÓRIO (docs/email/TELA.md).
// Só administrador; só com o módulo ligado no Super Admin.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/correio'),
      meta: {
        permissions: ['administrator'],
        featureFlag: FEATURE_FLAGS.CORREIO,
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'CORREIO.SERVIDOR.TITULO',
        icon: 'i-lucide-mail',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'correio_servidores',
          component: Index,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.CORREIO,
          },
        },
      ],
    },
  ],
};
